import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/jobSiteRepairOrderActions'
import * as api from '../../api/job/jobSiteRepairOrders'

function* fetchRepairOrderTemplates() {
  try {
    const payload = yield call(api.fetchRepairOrderTemplates)
    yield put({ type: constants.FETCH_REPAIR_ORDER_TEMPLATES.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.FETCH_REPAIR_ORDER_TEMPLATES.FAILED,
      message: e.message || e
    })
  }
}

function* watchFetchRepairOrderTemplates() {
  yield takeLatest(constants.FETCH_REPAIR_ORDER_TEMPLATES.ACTION, fetchRepairOrderTemplates)
}

export function* rootSaga() {
  // add more sagas here
  yield all([fork(watchFetchRepairOrderTemplates)])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobSiteRepairOrderSaga.js